import {
  BG_01,
  BENTO_GRID_DEFAULTS,
  hideBG01Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

const CARD_FIELDS = {
  cardImage: {
    type: "imageUrl",
  },
  cardImageAlt: {
    type: "string",
  },
  cardButtonImage: {
    type: "imageUrl",
  },
  cardButtonAlt: {
    type: "string",
  },
  cardButtonText: {
    type: "string",
  },
};

const createCardProp = (cardIndex, description) => ({
  type: "object",
  fields: CARD_FIELDS,
  defaultValue: BENTO_GRID_DEFAULTS[BG_01].cards[cardIndex],
  description: `${description} (BG01 only)`,
  hidden: hideBG01Props,
});

export const BG01_PLASMIC_PROPS = {
  contentHeading: {
    type: "string",
    defaultValue: BENTO_GRID_DEFAULTS[BG_01].contentHeading,
    description: "Main heading text (BG01 only)",
    hidden: hideBG01Props,
  },
  contentDescription: {
    type: "string",
    defaultValue: BENTO_GRID_DEFAULTS[BG_01].contentDescription,
    description: "Description text (BG01 only)",
    hidden: hideBG01Props,
  },
  buttonText: {
    type: "string",
    defaultValue: BENTO_GRID_DEFAULTS[BG_01].buttonText,
    description: "Primary button text (BG01 only)",
    hidden: hideBG01Props,
  },
  buttonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Primary button link type (BG01 only)",
    hidden: hideBG01Props,
  },
  buttonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open primary button in new tab (BG01 only)",
    hidden: hideBG01Props,
  },
  buttonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideBG01Props(props) ||
      (props.buttonLinkType !== OTHER_LINK_TYPE && props.buttonLinkType !== EXTERNAL_LINK_TYPE),
  },
  buttonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideBG01Props(props) ||
      (props.buttonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.buttonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  card1: createCardProp(0, "Card 1 - Featured card"),
  card2: createCardProp(1, "Card 2 - Right upper card"),
  card3: createCardProp(2, "Card 3 - Right bottom one"),
  card4: createCardProp(3, "Card 4 - Right bottom two"),
};
